<template>
  <div v-if="isShow" class="children-wrapper" ref="childrenWrapper">
    <router-view/>
  </div>
</template>

<script>
export default {
  computed: {
    isShow () {
      return !this.$route.meta.isParent
    }
  },
  watch: {
    isShow () {
      if (this.isShow) {
        this.$nextTick(this.setMinHeight)
      }
    }
  },
  mounted () {
    if (this.isShow) {
      this.setMinHeight()
    }
  },
  methods: {
    setMinHeight () {
      this.$refs.childrenWrapper.style.height = `${document.documentElement.clientHeight}px`
    }
  }
}
</script>

<style lang="less">
  .children-wrapper {
    background: #eee;
    left: 0;
    top: 0;
    right: 0;
    min-height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    position: absolute;
    z-index: 1000;
    -webkit-overflow-scrolling: touch;
  }
</style>
